import React, { useState } from "react";
import { Radio,Space } from "antd";
const MessageA22 = (props) => {
  const [value, setValue] = useState(null); // Initialize with null or any default value

  let data = props?.item?.text_data?.data

  const handleClick = (el) => {
    setValue(el.value);
    props.handleClick(props.item.code, el.value, null);
    props.setTextOnClick(el.value);
  };

  return (
    <div style={{ width: "fit-content"}} className="clickWrap action-tab">
      <Radio.Group value={value} style={{ color: "pink" }}>
        <Space direction="vertical">
          {data.map((el) => (
            <Radio
              key={el.code}
              value={el.value}
              onClick={() => handleClick(el)}
            >
              {el.value}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </div>
  );
};

export default MessageA22;